export default {
  baseUrl: '',
  accessToken: localStorage.getItem("RobohomeDataAccessToken") || null,
  home: localStorage.getItem("RobohomeActiveHome") || null,
  requestCancellers: {},
  scrolled: 0,
  storeActiveGroup: localStorage.getItem("RobohomeActiveGroup") || null,
  timezone: localStorage.getItem("RobohomeTZ") || null,
  themeColor: localStorage.getItem("RobohomeTheme") || null,
};
